<template>
  <div class="app-container" style="text-align: left">
    <!-- <el-radio-group v-model="platform" style="margin-left: 5px;margin-top: -28px;">
    <el-radio v-for="(item, index) in ckPlatforms" :label="item.label" :key="index" :value="item.value" style="margin-right: 12px;padding:4px 0px" @change="handleRadioChange"><img :src="item.imageUrl" style="position: relative;
  top: 10px;left:-2px;width: 30px; height: auto" /></el-radio>
  </el-radio-group> -->

  <div class="platDiv" @click="addClass('1')"
          :class="{ spanColors: platform === '1' }">
      <img
          src="@/assets/tb.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2.3px" />
      <span class="platSpan">淘宝</span>
    </div>
    <div class="platDiv" style="width: 96px" @click="addClass('2')"
          :class="{ spanColors: platform === '2' }">
      <img
          src="@/assets/pdd.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;margin-top: -1px" />
      <span class="platSpan">拼多多</span>
    </div>
    <div class="platDiv" @click="addClass('3')"
          :class="{ spanColors: platform === '3' }">
      <img
          src="@/assets/dy.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;margin-top: -1px" />
      <span class="platSpan">抖音</span>
    </div>
    <div class="platDiv" @click="addClass('4')"
          :class="{ spanColors: platform === '4' }">
      <img
          src="@/assets/jd.jpeg"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">京东</span>
    </div>
    <div class="platDiv" @click="addClass('5')"
          :class="{ spanColors: platform === '5' }">
      <img
          src="@/assets/ks.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">快手</span>
    </div>
    <div class="platDiv" style="width: 96px" @click="addClass('6')"
          :class="{ spanColors: platform === '6' }">
      <img
          src="@/assets/xhs.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">小红书</span>
    </div>
     <div class="platDiv" style="width: 96px" @click="addClass('7')"
          :class="{ spanColors: platform === '7' }">
      <img
          src="@/assets/tgc.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">淘工厂</span>
    </div>
    <div class="platDiv" style="width: 96px" @click="addClass('8')"
          :class="{ spanColors: platform === '8' }">
      <img
          src="@/assets/1688.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">1688</span>
    </div>
    <div class="platDiv" style="width: 96px" @click="addClass('9')"
          :class="{ spanColors: platform === '9' }">
      <img
          src="@/assets/sph.png"
          style="position: relative; width: 30px; height: auto;margin-left: -2px;border-radius: 0.5em;" />
      <span class="platSpan">视频号</span>
    </div>
    <div style="float: left;margin-left: 400px;" v-show="this.strip > 0">
      <span>{{ pingtai_data_cang }} ：{{ strip }}单</span>
    </div>

        <br><br>
    <div style="font-weight: bold; font-size: 16px; color: rgb(85, 85, 85); float: left;margin-top: 10px">
      手动发货
    </div>
    <br />
    <div class="zfxx" style="margin-top: 20px">
      <svg width="22" height="22">
        <circle cx="10" cy="10" r="8" stroke="#dee6fe" stroke-width="1" fill="#dee6fe" />
        <circle cx="10" cy="10" r="3" stroke="#0850fc" stroke-width="3" fill="#0850fc" />
      </svg>
      <span class="djb">第一步</span>
    </div>
    <div style="margin-left: 10px; border-left: #c3c3c3 dashed 1px; padding-bottom: 15px">
      <div class="djb_desc">选择发送物流</div>
      <div style="margin-left: 0px; margin-top: 5px">
        <el-select
          style="width: 450px; margin-left: 20px"
          v-model="lpfsQuery.pingtai_data_id"
          @change="cangkuClick"
          placeholder="代发仓库"
          class="filter-item"
        >
          <el-option
            v-for="item in cangkuList"
            :key="item.id"
            :label="item.desc_name"
            :value="item.id"
          >
            <span>
              <img
                v-if="item.kuaidi.pic"
                :src="item.kuaidi.pic"
                alt="图标"
                style="width: 60px; height: 30px; margin-right: 8px"
              />
              {{ item.desc_name }}
            </span>
          </el-option>
        </el-select>
        <span style="margin-left: 20px">发货地址：{{ fhAddress }} </span>
      </div>
    </div>

    <div class="zfxx">
      <svg width="22" height="22">
        <circle cx="10" cy="10" r="8" stroke="#dee6fe" stroke-width="1" fill="#dee6fe" />
        <circle cx="10" cy="10" r="3" stroke="#0850fc" stroke-width="3" fill="#0850fc" />
      </svg>
      <span class="djb">第二步</span>
    </div>

    <div style="margin-left: 10px; border-left: #c3c3c3 dashed 1px; padding-bottom: 15px">
      <div class="djb_desc">填写发/收货信息</div>
      <div
        class="select_span"
        style="margin-left: 20px; margin-top: 5px; padding-bottom: 5px; width: 200px;"
      >
        <span style="padding: 0 10px 0 10px; border-right: #c3c3c3 solid 1px">发件人姓名</span
        ><input
          style="width: 100px; margin-left: 7px;height:29px"
          v-model="send_name"
          placeholder="刘先生"
        ></input>
        </div>
        <div class="select_span"
        style="margin-left: 230px;margin-top: -32px; width: 220px;padding:5px 7px">
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 7px;">发件人电话</span>
        <el-dropdown trigger="click" placement="bottom-start">
            <span class="el-dropdown-link">
              {{ send_tel }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                    v-for="(item, index) in sendtelList"
                    :key="index"
                    :label="item"
                    :value="item">
                <!-- <div style="display: flex; justify-content: space-between; align-items: center;"> -->
                  <span @click="liClicked(item)">{{ item }}</span> &nbsp;&nbsp;&nbsp;
                  <el-button type="text" style="color: red;background-color: white; border:0px solid white" @click="deleteItem(item)">删除</el-button>
                <!-- </div> -->
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

        </div>
        <div
        style="margin-left: 457px;margin-top: -32px; width: 720px;padding:0px 7px">
        
        <el-button
            style="
              font-size: 12px;
              color: #0850fc;
              border-color: #0850fc;
              height: 34px;
              border-radius: 0.5em;
              padding: 3px 10px;
              background-color: white; 
            "
            @click="sendCodeCheck()"
            >添加手机号</el-button
          >
        </div>
<br>
      <div  v-if="this.platform == 1"
        style="margin-left: 10px; margin-top: -10px; padding-bottom: 0px; width: 270px; float:left;"
      >
        <span style="padding: 0 10px 0 10px;font-weight: bold"
          >收货信息设置:</span>
          <input type="checkbox" id="enableFeature" v-model="cgdshInfo" style="margin-top: -5px;vertical-align: middle;">
          <label for="enableFeature">使用采购单收货信息</label>
        <!-- <span>使用采购单收货信息</span> -->
      </div>
        <div
        class="select_span"
        style=" margin-top: -15px; padding-bottom: 5px; width: 270px; float:left;"
      >
        <span style="padding: 0 10px; border-right: #c3c3c3 solid 1px"
          >自定义收货人电话</span>
        <input
          style="width: 120px; margin-left: 7px"
          v-model="lpfsQuery.zdy_phone"
        ></input>
      </div>
      <br>  
      <div class="djb_desc" style="margin-top: 3px">代发礼品：</div>
      <div style="margin-top: 10px; display: flex;">
        <div 
          v-for="(item, index) in goods" 
          :key="index" 
          class="lipin_img_div" 
          :class="{ 'selected': selectedGiftIndex === index }"
          @click="selectGift(item, index)"
        >
          <img :src="item.pic" alt="Image" class="lipin_img" />
          <div class="gift-price">￥{{ item.price || '0.00' }}</div>
          <div class="gift-name">{{ item.name || '' }}</div>
          <div>
            <el-input v-model="lpfsQuery.goods_id" v-show="false"></el-input>
            <el-input v-model="lpfsQuery.goods_price" v-show="false"></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="zfxx">
      <svg width="22" height="22">
        <circle cx="10" cy="10" r="8" stroke="#dee6fe" stroke-width="1" fill="#dee6fe" />
        <circle cx="10" cy="10" r="3" stroke="#0850fc" stroke-width="3" fill="#0850fc" />
      </svg>
      <span class="djb">第三步</span>
    </div>
    <div style="margin-left: 30px">
      <div class="djb_desc" style="margin-left: 0px">
        筛选订单列表， 获取单号并发送礼品
      </div>
      <!-- <div style="font-weight: 400; color: red; padding-top: 5px">
        未关联拍单软件账号&nbsp;&nbsp;&nbsp;
        <span
          style="
            font-size: 13px;
            font-weight: bold;
            color: #f7aa35;
            border: #f7aa35 2px solid;
            border-radius: 1em;
          "
          >&nbsp;?&nbsp;</span
        >&nbsp;&nbsp;<span style="color: #f7aa35"
          >说明:请先关联拍单软件识别码，才能同步订单发货或使用中转仓</span
        >
      </div> -->
      <div
        class="select_span"
        style="margin-left: 0px; margin-top: 5px; padding-bottom: 5px;  width: 410px; height:33px"
      >
        <span style="padding: 0 10px 0 10px;">成交时间</span>
        <date-picker
          v-model="startDate"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间" 
          :picker-options="pickerOptionsStart"
          class="borderless"
        ></date-picker>
        <span>至&nbsp;</span>
        <date-picker
          v-model="endDate"
          :default-time="['23:59:59']"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="结束时间"
          :picker-options="pickerOptionsEnd"
          class="borderless"
        ></date-picker>
         <!-- <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          v-model="startDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="起始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker> -->
        
      </div>
      
     <div class="select_span"
        style="margin-left: 417px;margin-top: -32px; width: 180px;padding:0px 7px">
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 7px;">分组名</span>
        <select
          v-model="listQuery.shop_group_name"
          class="filter-item"
          style="width: 108px"
          @change="getShowNameByGroup"
          clearable
        >
          <option
            v-for="(item, index) in shopGroupList"
            :key="index"
            :label="item"
            :value="item"
            >{{ item }}</option
          >
        </select>
      </div>
        
      <div class="select_span"
        style="margin-left: 606px;margin-top: -32px; width: 190px;padding: 0px 7px">
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 7px;">店铺名</span>
        <select
          v-model="listQuery.show_name"
          class="filter-item"
          style="width: 118px"
          clearable
        >
          <option
            v-for="(item, index) in shopList"
            :key="index"
            :label="item"
            :value="item"
            >{{ item }}</option
          >
        </select>
      </div>

      
      <div
        class="select_span"
        style="margin-left:804px; margin-top: -32px; padding-bottom: 5px; width: 270px;"
      >
        <span style="padding: 0 10px 0 10px; border-right: #c3c3c3 solid 1px">订单编号</span>
        <input
          v-model="listQuery.order_no"
          style="width: 180px;"
          class="filter-item"
          clearable
        />
        </div>


      <div class="select_span"
        style="margin-left: 0px; width: 410px;padding: 5px 10px; margin-top: 8px;">
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 7px;">旗帜状态</span>
        <el-checkbox-group v-model="listQuery.flag" style="margin-left: 75px;margin-top: -25px;">
    <el-checkbox v-for="(item, index) in flags" :label="item.label" :key="index" :value="item.value" style="margin-right: 12px;padding:4px 0px"><img :src="item.imageUrl" style="position: relative;
  top: 4px;left:-2px;width: 15px; height: 15px" /></el-checkbox>
  </el-checkbox-group>
        </div>

    <div class="select_span"
        style="margin-left: 417px;margin-top: -32px; width: 380px;padding: 5px 10px;">
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 7px;">采购平台</span>
        <el-checkbox-group v-model="listQuery.cg_platform" style="margin-left: 75px;margin-top: -29px;">
    <el-checkbox v-for="(item, index) in buyPlatforms" :label="item.label" :key="index" :value="item.value" style="margin-right: 12px;padding:4px 0px"><img :src="item.imageUrl" style="position: relative;
  top: 4px;left:-2px;width: 20px; height: auto" /></el-checkbox>
  </el-checkbox-group>
        </div>

    <div class="select_span"
        style="margin-left: 804px;margin-top: -32px; padding: 0px 10px;width: 270px;">
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 10px;">订单状态</span>
        <select
          v-model="listQuery.orderStatus"
          class="filter-item"
          style="width: 175px"
        >
          <option
            v-for="item in orderStasList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </select>
  </div>

  <div class="select_span"
        style="margin-left: 0px; width: 797px;padding: 5px 10px; margin-top: 8px;">
        <span style="border-right: #c3c3c3 solid 1px; padding-right: 7px;">仅匹配选中快递</span>
        <el-checkbox-group v-model="listQuery.kuai_name" style="margin-left: 145px;margin-top: -25px;">
    <el-checkbox v-for="(item, index) in kuaidiLists" :label="item" :key="index":value="item" style="margin-right: 12px;padding:4px 0px">{{ item }}</el-checkbox>
  </el-checkbox-group>
  </div>
  
  <div
        style="margin-left: 820px;margin-top: -32px;">
        <el-button
          type="primary"
          @click="getList"
          >查询</el-button
        >
      </div>
    </div>
    <div
      style="font-weight: bold; font-size: 20px; color: rgb(85, 85, 85); margin-top: 15px"
    >
      订单列表
    </div>
    <el-button
      type="primary"
      @click="buyLp"
      :disabled="isDisabled"
      >获取单号并发送礼品</el-button
    >
    <el-button
      type="primary"
      @click="lpfsResultShow"
      >发送记录</el-button
    >
    <el-button
      type="danger"
      @click="openCancelOrderDialog"
      >取消订单</el-button
    >
    <span v-if="isDisabled" style="margin-left:30px;color:red;font-size:22px">已选订单正在发送礼品，不要重复点击发送按钮，请耐心等待 。 。 。</span>
    
    <el-tabs v-model="activeTab" style="margin-top: 20px">
      <el-tab-pane label="待发送" name="pending"></el-tab-pane>
      <el-tab-pane label="正在发送" name="sending"></el-tab-pane>
    </el-tabs>
    <div style="width: 86vw;max-height: 500px;overflow-y:scroll">
    <el-table
      v-loading="listLoading"
      :data="filteredList"
      fit
      highlight-current-row
      style="max-width: 86vw;color: rgb(70, 70, 70); margin-top: 10px"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '3px 0' }"
      :header-cell-style="{
        background: 'rgb(247 248 252) !important',
        color: '#ededed  !important',
        padding: '7px 0',
        color: 'rgb(140, 140, 140)',
      }"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50px" fixed="left" align="left" checked="allChecked" v-if="activeTab === 'pending'">
      </el-table-column>
      <el-table-column label="序号" width="50px" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.idx }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="left" width="100px">
        <template slot-scope="{ row }">
          <img :src="getImageUrl(row.flag)" alt="Image">
          <span>{{ activeTab === 'pending' ? row.remarks : row.remarks ? row.remarks : '正在发送'}}</span>
        </template>
      </el-table-column>
        <el-table-column label="平台" align="left" width="85px">
          <template slot-scope="{ row }">
            <span class="ellipsis" :title="platList[row.platform]">{{
              platList[row.platform]
            }}</span>
          </template>
        </el-table-column>
      <el-table-column label="店铺名称" align="left" width="85px">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.shop_name">{{ row.shop_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单编号" width="180px" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.order_no }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="80px" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.addressee">{{ row.addressee }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" align="left"  width="150px">
        <template slot-scope="{ row }">
          <span>{{ row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收货地址" width="90px" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.province">{{ row.province }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单状态" width="105px" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.order_status">{{ row.order_status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="采购平台" width="80px" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.cg_platform">{{ row.cg_platform }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上家快递" width="85px" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.express_pro">{{ row.express_pro }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上家快递单号" align="left" width="130px">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.express_no">{{ row.express_no }}</span>
        </template>
      </el-table-column>
      <el-table-column label="快递公司" width="100px" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.kdName">{{ row.kdName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="生成快递单号" width="150px" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.newOrder }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="成交时间" align="left" width="120px">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.trade_time">{{ row.trade_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" align="left" width="120px">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.handle_time">{{ row.handle_time }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div> 
    <pagination
          v-show="(activeTab === 'pending' ? total : sendingTotal) > 0"
          :total="activeTab === 'pending' ? total : sendingTotal"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.perPage"
          :page-sizes="[10, 20, 50, 100]"
          style="padding-top: 12px; padding-bottom: 0px; text-align: left"
          @pagination="activeTab === 'pending' ? getList() : getSending()"
        />

    <!-- 自动发送实时返回数据展示弹出框 -->
    <el-dialog
      title="发送结果"
      :visible.sync="dialogFormVisible"
      style="
        text-align: center;
        width: 100%;
        height: 120%;
        overflow-y: auto;
        padding: 0px;
      "
    >
      <el-form
        :model="lpfsResult"
        style="
          width: 100%;
          height: 100%;
          overflow-y: auto;
          white-space: pre-line;
          text-align: left;
          margin-top: -50px;
        "
      >
        <el-form-item style="padding: 0; margin: 0">
          <span>
            {{ lpfsResult.data }}
          </span></el-form-item
        >
      </el-form>
    </el-dialog>

     <!-- 短信验证弹出框 -->
      <el-dialog
        title="添加手机号-短信验证"
        :visible.sync="sendCodeFormVisible"
        style="
          text-align: center;
          width: 60%;
          height: 120%;
          overflow-y: auto;
          padding: 0px;
          margin-left: 16%;
          margin-top: 5%;
        "
      >
        <el-form
         class="form"
              :model="phoneForm"
              :rules="rules"
              ref="phoneForm"
              label-width="0px"
            >
            <!-- <div style="margin-bottom: 20px;color:red">
            因移动手机号运营商问题，验证码接收失效率高，尽量切换电信或联通手机号
            </div> -->
              <el-form-item prop="phone">
                <el-input
                  v-model="phoneForm.phone"
                  placeholder="请输入手机号"
                  prefix-icon="el-icon-mobile-phone"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  v-model="phoneForm.code"
                  placeholder="请输入验证码"
                  prefix-icon="el-icon-chat-line-round"
                ></el-input>
                <!-- <a type="button" @click="sendCode">获取验证码</a> -->
                <a type="button" @click="sendCode" :disabled="countdown > 0">
                  {{ countdown > 0 ? `${countdown}秒后重新获取` : "获取验证码" }}
                </a>
              </el-form-item>
            </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateUserInfo()"> 确认 </el-button>
        <el-button @click="sendCodeFormVisible = false"> 取消 </el-button>
      </div>
      </el-dialog>

      <!-- 取消订单弹出框 -->
      <el-dialog
        title="取消订单"
        :visible.sync="cancelOrderFormVisible"
        width="420px"
      >
        <el-form label-width="80px">
          <el-form-item label="订单编号">
            <el-input
              v-model="cancelOrderNo"
              placeholder="请输入订单编号"
              clearable
              @keyup.enter.native="confirmCancelOrder"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelOrderFormVisible = false">放弃</el-button>
          <el-button
            type="primary"
            :loading="cancelOrderLoading"
            @click="confirmCancelOrder"
            >确认取消</el-button
          >
        </div>
      </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import waves from "@/directive/waves"; // waves directive
// import "@/assets/custom-theme/index.css"; // the theme changed version element-ui css
import { DatePicker } from "element-ui";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
// import MaskLayer from "../MaskLayer.vue"; // 遮罩层
import horizontalScroll from 'el-table-horizontal-scroll'
import moment from "moment";
import { RadioGroup, Radio } from 'element-ui';

export default {
  name: "plSend",
  directives: { waves,horizontalScroll },
  components: {
    Pagination,
    "el-date-picker": DatePicker,
    // MaskLayer,
    'el-radio-group': RadioGroup,
    'el-radio': Radio
  },
  filters: {
    flagFilter(flag) {
      const flagMap = {
        0: require("@/assets/qz0.png"),
        1: require("@/assets/qz1.png"),
        2: require("@/assets/qz2.png"),
        3: require("@/assets/qz3.png"),
        4: require("@/assets/qz4.png"),
        5: require("@/assets/qz5.png"),
      };
      return flagMap[flag];
    },
  },
  data() {
    return {
      userToken: Cookies.get("view_userToken"),
      selected_kuaidi: { id: "", name: "" },
      fhAddress: "",
      // price: "",
      goods: [],
      goodsImg: "",
      platform: 1,
      selectedGiftIndex: -1,
      // platList: [
      //   { value: 1, name: "淘宝" },
      //   { value: 2, name: "拼多多" },
      //   { value: 3, name: "抖音" },
      //   { value: 4, name: "京东" },
      //   { value: 5, name: "快手" },
      // ],

      listQuery: {
        page: 1,
        perPage: 100,
        express_type: 1,
        date_one: "",
        date_two: "",
        order_no: "",
        shop_group_name: "",
        show_name: "",
        orderStatus: 3,
        gift_status: 1,
        transfer_flag: 1,
        // flag: ["0", "1", "2", "3", "4", "5"],
        flag: [],
        // cg_platform: ["淘宝","淘特", "1688", "拼多多", "抖音"],
        cg_platform: [],
        kuai_name: [],
      },
      lpfsQuery: {
        list: [],
        pingtai_data_id: "",
        express_type: 1,
        goods_id: "",
        goods_price: "",
        kuaidi_price: "",
        fjr: "",
        zdy_phone: "",
        fsTk: 1,
        // 仓库类型
        ckType: "",
      },
      total: 0,
      sendingTotal: 0,
      listLoading: false,
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        new Date().getDate()
      ),
      endDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(), 23, 59, 59),
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime(); //选则的时间
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      shopGroupList: [],
      shopList: [],
      orderStasList: [
        { value: 1, name: "待下单" },
        { value: 2, name: "待发货" },
        { value: 3, name: "待发货,已有上家单号" },
        { value: 4, name: "待下单和待发货" },
      ],
      otCheckAll: true,
      bpCheckAll: true,
      ckPlatforms: [
        { value: "1", imageUrl: require("@/assets/tb.png"), label: "1" },
        { value: "2", imageUrl: require("@/assets/pdd.png"), label: "2" },
        { value: "3", imageUrl: require("@/assets/dy.png"), label: "3" },
        { value: "4", imageUrl: require("@/assets/jd.jpeg"), label: "4" },
      ],
      buyPlatforms: [
        { value: "淘宝", imageUrl: require("@/assets/tb.png"), label: "淘宝" },
        { value: "淘特", imageUrl: require("@/assets/tbtjb.png"), label: "淘特" },
        { value: "1688", imageUrl: require("@/assets/1688.png"), label: "1688" },
        { value: "拼多多", imageUrl: require("@/assets/pdd.png"), label: "拼多多" },
        { value: "抖音", imageUrl: require("@/assets/dy.png"), label: "抖音" },
      ],
      flags: [
        { value: "0", imageUrl: require("@/assets/qz0.png"), label: "0", },
        { value: "1", imageUrl: require("@/assets/qz1.png"), label: "1", },
        {
          value: "2",
          imageUrl: require("@/assets/qz2.png"),
          label: "2",
        },
        {
          value: "3",
          imageUrl: require("@/assets/qz3.png"),
          label: "3",
        },
        {
          value: "4",
          imageUrl: require("@/assets/qz4.png"),
          label: "4",
        },
        {
          value: "5",
          imageUrl: require("@/assets/qz5.png"),
          label: "5",
        },
      ],
      expressTypes: [
        { value: 1, name: "否" },
        { value: 2, name: "是" },
      ],
      kdCheckAll: false,
      kuaidiLists: [
        "中通",
        "圆通",
        "申通",
        "韵达",
        "邮政",
        "极兔",
        "德邦",
        "顺丰",
        "丰网",
      ],
      cangkuList: [],
      list: [],
      multipleSelection: [], // 被选中的行
      allSelectedDatas: [], // 被选中的行
      allChecked: true,
      // showMask: false,
      user_balance: "",
      pingtai_data_cang: "",
      strip: 0,
      dialogFormVisible: false,
      lpfsResult: { data: "" },
      send_name:"",
      send_tel: "",
      sendtelList:[],
      sendCodeFormVisible: false,
      phoneForm:{
        phone: "",
        code:"",
      },
      countdown: 0, // 倒计时时间
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号格式错误", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      cgdshInfo: false,
      platList: {
        1: "淘宝",
        2: "淘特",
        3: "拼多多",
        4: "天猫",
        5: "1688",
        6: "抖音",
        7: "孔夫子",
        8: "小红书",
        9: "快手",
        10: "淘工厂",
        11: "咸鱼",
      },
      isDisabled: false,
      activeTab: 'pending', // Tab 标签：pending-待发送, sending-正在发送
      sendingList: [], // 正在发送的订单列表
      cancelOrderFormVisible: false,
      cancelOrderNo: "",
      cancelOrderLoading: false,
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === 'sending') {
        // 正在发送：显示从接口获取的正在发送的订单
        return this.sendingList;
      } else {
        // 待发送：显示待发送的订单
        return this.list;
      }
    },
  },
  watch: {
    // 监听标签切换，调用对应的接口
    activeTab(newVal) {
      if (newVal === 'sending') {
        this.getSending();
      } else {
        this.getList();
      }
    },
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      // this.$confirm("请先登录再使用！", "提示", {
      //   confirmButtonText: "确定",
      // })
      //   .then(() => {
      //     // 重新导航到登录页面
      //     localStorage.clear();
      //     this.$root.removeCookies();
      //     this.$router.push({ path: "/login" });
      //     return;
      //   })
      //   .catch(() => {
      //     // 重新导航到首页
      //     localStorage.clear();
      //     this.$root.removeCookies();
      //     this.$router.push({ path: "/" });
      //     return;
      //   });
      // return;
    } else {
      this.$root.getSystemInfo();
      this.addClass('1');
      this.getShowName();
      this.getUserBalance();
      if (Cookies.get("view_sendName") != null && Cookies.get("view_sendName") != "null" && Cookies.get("view_sendName") != ""  && Cookies.get("view_sendName") != "undefined"  && Cookies.get("view_sendName") != undefined) {
        this.send_name = Cookies.get("view_sendName");
      }
      if (Cookies.get("view_sendTel") != null && Cookies.get("view_sendTel") != "null" && Cookies.get("view_sendTel") != ""  && Cookies.get("view_sendTel") != "undefined"  && Cookies.get("view_sendTel") != undefined) {
        this.sendtelList = JSON.parse(Cookies.get("view_sendTel"));
      }

      if (Cookies.get("view_fjr") != null && Cookies.get("view_fjr") != "null" && Cookies.get("view_fjr") != undefined && Cookies.get("view_fjr") != "undefined") {
        const fjrStr = Cookies.get("view_fjr");
        this.lpfsQuery.fjr = fjrStr;
        const index = fjrStr.indexOf(',');
        if (index != -1) {
          const st = fjrStr.substring(index + 1); // 逗号后面的部分
          if (this.sendtelList.indexOf(st) != -1) {
            this.send_tel = st;
          }
        }
        const index1 = fjrStr.indexOf('，');
        if (index1 != -1) {
          const st1 = fjrStr.substring(index1 + 1); 
          if (this.sendtelList.indexOf(st1) != -1) {
            this.send_tel = st1;
          }
        }
      } else {
        this.lpfsQuery.fjr = "";
      }
    }
  },
  mounted() {
    // this.getList();
    this.toggleSelectAll(); // 在mounted钩子中调用
  },
  methods: {
    getList() {
      this.listLoading = true;
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      this.listQuery.date_one = moment(this.startDate).format("YYYY-MM-DD HH:mm:ss");
      this.listQuery.date_two = moment(this.endDate).format("YYYY-MM-DD HH:mm:ss");
      const url = this.$root.commonPreUrl + "/index/getOrder";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.listLoading = false;
            const resData = resd.data || {};
            const rawList = resData.data;
            if (Array.isArray(rawList)) {
              this.list = rawList;
            } else if (rawList && typeof rawList === "object") {
              this.list = Object.values(rawList);
            } else {
              this.list = [];
            }
            const total = resData.total;
            this.total = total !== undefined ? total : this.list.length;
            this.list.forEach((item, index) => {
              item.idx = index+1;
            });
            this.$nextTick(() => {
              // 在DOM更新后执行
              this.$refs.multipleTable.toggleAllSelection();
            });
          }
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
              localStorage.clear();
              this.$root.removeCookies();
              this.$router.push({ path: "/login" });
          }
          return;
        });
    },
    getSending() {
      this.listLoading = true;
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      this.listQuery.date_one = moment(this.startDate).format("YYYY-MM-DD HH:mm:ss");
      this.listQuery.date_two = moment(this.endDate).format("YYYY-MM-DD HH:mm:ss");


      const url = this.$root.commonPreUrl + "/index/getSending";
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userToken,
      };
      const res = axios.post(url, this.listQuery, { headers: headers });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.listLoading = false;
            const sendingData = resd.data;
            if (Array.isArray(sendingData)) {
              this.sendingList = sendingData;
              this.sendingTotal = sendingData.length;
            } else {
              this.sendingList = (sendingData && sendingData.data) || [];
              const total = sendingData ? sendingData.total : 0;
              this.sendingTotal = total || this.sendingList.length;
            }
            this.sendingList.forEach((item, index) => {
              item.idx = index + 1;
            });
            this.$nextTick(() => {
              // 在DOM更新后执行
              if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection();
              }
            });
          }
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
          console.error("获取正在发送订单失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
              localStorage.clear();
              this.$root.removeCookies();
              this.$router.push({ path: "/login" });
          }
          return;
        });
    },
    getCk() {
      //更换平台时，调用接口获取平台对应仓库列表
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      this.cangkuList = [];
      this.lpfsQuery.pingtai_data_id = "";
      this.lpfsQuery.ckType = "";
      this.fhAddress = "";
      this.goods = [];

      const url = this.$root.commonPreUrl + "/index/getCk";
      const system_id = Cookies.get("view_system_id");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { platform: this.platform, system_id: system_id },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const list = Array.isArray(resd.data) ? resd.data : [];
            this.cangkuList = list.map((item) => {
              const kuaidi = item.kuaidi || {};
              const goods = Array.isArray(item.goods) ? item.goods : [];
              const pic = kuaidi.pic ? `${this.$root.staticUrl}storage/${kuaidi.pic}` : "";
              return {
                ...item,
                kuaidi: {
                  ...kuaidi,
                  pic,
                },
                goods: goods.map((goodsItem) => ({
                  ...goodsItem,
                  pic: goodsItem.pic ? `${this.$root.staticUrl}storage/${goodsItem.pic}` : "",
                })),
                desc_name: item.processed_member
                  ? `${item.desc_name}， ￥${item.processed_member}`
                  : item.desc_name,
              };
            });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
              localStorage.clear();
              this.$root.removeCookies();
              this.$router.push({ path: "/login" });
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },

    cangkuClick() {
      const selected_cid = this.lpfsQuery.pingtai_data_id;
      // 使用forEach方法遍历数组并取值
      this.cangkuList.forEach((item, index) => {
        const cid = item.id;
        if (cid == selected_cid) {
          // 给快递赋值
          this.selected_kuaidi = item.kuaidi || {};
          // 快递费  先取当前登录用户等级
          // const grade = Cookies.get("view_grade");
          //this.price = item.member;
          this.lpfsQuery.kuaidi_price = item.processed_member || "";
          // 给发货地址赋值
          this.fhAddress = item.address;
          //  给代发礼品赋值
          this.goods = Array.isArray(item.goods) ? item.goods : [];
          if (this.goods.length > 0) {
            // 默认选中第一个礼品
            this.selectedGiftIndex = 0;
            this.lpfsQuery.goods_id = this.goods[0].id || "";
            this.lpfsQuery.goods_price = this.goods[0].member || "";
          } else {
            this.selectedGiftIndex = -1;
            this.lpfsQuery.goods_id = "";
            this.lpfsQuery.goods_price = "";
          }
          this.lpfsQuery.ckType = item.type;
        }
      });
    },
    getShowName() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getShowName";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "1") {
            this.shopGroupList = resd.data.group_name;
            this.shopList = resd.data.shop_name;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val; // 当选项发生变化时，重新赋值
      this.allSelectedDatas = val;
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        this.$refs.multipleTable.toggleAllSelection();
      });
    },
    async buyLp() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        // 重新导航到登录页面
        localStorage.clear();
         this.$root.removeCookies();
         this.$router.push({ path: "/login" });
         return;
      }
      
      const sendTel = this.send_tel;
      if (sendTel == "" || sendTel == "null" || sendTel == null || sendTel == undefined || sendTel == "undefined") {
        this.$confirm("请先选择正确的发件人电话！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            return;
          })
          .catch(() => {
            return;
          });
        return;
      }
      let sendName = this.send_name;
      if (sendName=="") {
        sendName = "1"
      }
      this.lpfsQuery.fjr = sendName + "," + sendTel;

      let data = this.allSelectedDatas;
      if (data.length == 0) {
        this.$confirm("请先选择订单再发送礼品!", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: undefined, // 取消按钮不显示
        })
          .then(() => {})
          .catch(() => {});
        return;
      }
      this.isDisabled = true;
     // this.dialogFormVisible = true;
      let allDatas = [];
      data.forEach((item) => {
        item.handle_time = "";
        allDatas.push(item);
      });

      this.listLoading = true;
      this.lpfsResult.data = "";
      const url = this.$root.commonPreUrl + "/index/buyLp";
      for (let index = 0; index < allDatas.length; index++) {
        const item = allDatas[index];
          
        let lpfsParams = JSON.parse(JSON.stringify(this.lpfsQuery));
        
        let dpPlat = 0;
        if (item.platform == 1) {
          dpPlat = 0;
        } else if (item.platform == 12) {
          dpPlat = 2;
        }  else if (item.platform == 3) {
          dpPlat = 4;
        } else if (item.platform == 6) {
          dpPlat = 5;
        } else if (item.platform == 9) {
          dpPlat = 6;
        } else if (item.platform == 8) {
          dpPlat = 7;
        }
        let cgPlat = item.cg_platform_id;
        if (item.cg_platform == '1688') {
          cgPlat = 0;
        } else if  (item.cg_platform == '京东') {
          cgPlat = 2;
        }  else if (item.cg_platform == '拼多多') {
          cgPlat = 4;
        } else if (item.cg_platform == '抖音')  {
          cgPlat = 5;
        } else if (item.cg_platform == '快手') {
          cgPlat = 6;
        } else if (item.cg_platform == '小红书')  {
          cgPlat = 7;
        }
        let cg_mobile = item.cg_mobile;
        let cg_addressee = item.cg_addressee;
        let cg_platform_id = item.cg_platform_id;
        
        if (!cg_mobile) {
          if (item.childOrderList && item.childOrderList.length > 0) {
            cg_mobile = item.childOrderList[0].cg_mobile;
          }
        }

        if (!cg_addressee) {
          if (item.childOrderList && item.childOrderList.length > 0) {
            cg_addressee = item.childOrderList[0].cg_addressee;
          }
        }

        if (!cg_platform_id) {
          if (item.childOrderList && item.childOrderList.length > 0) {
            cg_platform_id = item.childOrderList[0].cg_platform_id;
          }
        }
        cg_mobile = cg_mobile || '';
        cg_addressee = cg_addressee || '';
        cg_platform_id = cg_platform_id || '';

        let shrList = {
          order_id: item.id,
          order_no: item.order_no,
          address: item.address,
          province: item.province,
          city: item.city,
          area: item.area,
          town: item.town,
          mobile: item.mobile || '',
          addressee: item.addressee || '',
          express_no: item.express_no,
          express_pro: item.express_pro,
          cg_mobile: cg_mobile,
          ship_address: item.ship_address,
          //2025 0902 加四个参数 sourcecode  targetname  enterchannel  deliverychannel
          sourcecode: item.express_no,
          targetname: item.cg_platform,
          enterchannel: dpPlat,
          deliverychannel: cgPlat,
          //2025 1013 吉时达不接及时零售平台的单  需传platform字段
          platform: item.platform,
          shop_id: item.shop_id,
          good_id: item.good_id,
          shop_name: item.shop_name,
          good_name: item.good_name,
          number: item.number,
          sku: item.sku,
          good_img: item.good_img,
          trade_time: item.trade_time,
          cg_platform_id: cg_platform_id,
          

          cg_addressee: cg_addressee, // 上家收件人
          cg_address: item.cg_address || '', // 上家地址

        };
        if (this.platform == 1 && this.cgdshInfo == true) {
          shrList.mobile = cg_mobile;
          shrList.addressee = cg_addressee;
        };
        lpfsParams.list = JSON.stringify([shrList]);
        lpfsParams = JSON.stringify(lpfsParams);
        const headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userToken,
        };
        console.log("原始 item 数据", item);
        console.log("需要发送订单参数", lpfsParams);
        await axios.post(url, lpfsParams, { headers: headers })
          .then((response) => {
            const resd = response.data;
            if (resd.code == "200") {
              this.lpfsResult.data =
                this.lpfsResult.data +
                "订单【" +
                item.order_no +
                "】--" +
                resd.msg +
                "；生成快递单号：" +
                resd.data.newOrder +
                "；\n";
              //  给表格数据赋值
              data.forEach((item1) => {
                if (item1.express_no == item.express_no) {
                  item1.kdName = resd.data.kdName;
                  item1.newOrder = resd.data.newOrder;
                  item1.remarks = resd.msg;
                  item1.handle_time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                }
              });
            } else if (resd.code == "202") {
              const respOrderNo = (resd.data && resd.data.order_no) || item.order_no;
              this.lpfsResult.data =
                this.lpfsResult.data +
                "订单【" +
                respOrderNo +
                "】--" +
                resd.msg +
                "；正在发送；\n";

              data.forEach((item1) => {
                if (item1.order_no == respOrderNo) {
                  item1.remarks = resd.msg;
                  item1.handle_time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                }
              });

              try {
                const removeIndex = this.list.findIndex((l) => l.order_no === respOrderNo || l.id === item.id);
                if (removeIndex !== -1) {
                  this.list.splice(removeIndex, 1);
                  this.list.forEach((it, idx) => {
                    it.idx = idx + 1;
                  });
                  this.total = Math.max(0, this.total - 1);
                }

                this.multipleSelection = this.multipleSelection.filter((s) => s.order_no !== respOrderNo && s.id !== item.id);
                this.allSelectedDatas = this.allSelectedDatas.filter((s) => s.order_no !== respOrderNo && s.id !== item.id);
                if (this.$refs.multipleTable) {
                  this.$refs.multipleTable.clearSelection();
                  this.multipleSelection.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                  });
                }
              } catch (e) {
                console.warn('正在发送异常', e);
              }
            } else {
              this.lpfsResult.data =
                this.lpfsResult.data +
                "订单" +
                item.order_no +
                "--发送失败，原因：" +
                resd.msg +
                " ;\n";
              data.forEach((item1) => {
                if (item1.express_no == item.express_no) {
                  item1.remarks = resd.msg;
                }
              });
            }
            setTimeout(() => {
              return;
            }, 1.5 * 1000);
          })
          .catch((error) => {
            console.error("初始请求失败:", error);
            if (
              JSON.stringify(error).includes("Error: Request failed with status code 401")
            ) {// 重新导航到首页
              localStorage.clear();
              this.$root.removeCookies();
              this.$router.push({ path: "/login" });
              return;
            }
          })
          .finally(() => {
            if (index == allDatas.length - 1) {
              // this.dialogFormVisible = true;
              this.isDisabled = false;
              this.getList();
            }
          });
          // await new Promise(resolve => setTimeout(resolve, 1500));
        };    
      // });
      this.getUserBalance();
      this.listLoading = false;
    },

    getUserBalance() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        // 重新导航到登录页面
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getUserBalance";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });

      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            const data = resd.data;
            this.user_balance = data.user_balance;
            if (data.userStrip.length > 0) {
              this.pingtai_data_cang = data.userStrip[0].pingtai_data_cang;
              this.strip = data.userStrip[0].strip;
            }

            Cookies.set("view_userBalance", data.user_balance, { expires: 1 });
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
            return;
              
          }

        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },

    getShowNameByGroup() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        // 重新导航到登录页面
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        
        return;
      }

      const url = this.$root.commonPreUrl + "/index/getShowName";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { shop_group_name: this.listQuery.shop_group_name },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "1") {
            this.shopList = resd.data.shop_name;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
              
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    lpfsResultShow() {
      this.dialogFormVisible = true;
    },
    openCancelOrderDialog() {
      this.cancelOrderNo = "";
      this.cancelOrderFormVisible = true;
    },
    confirmCancelOrder() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        localStorage.clear();
        this.$root.removeCookies();
        this.$router.push({ path: "/login" });
        return;
      }

      const orderNo = (this.cancelOrderNo || "").trim();
      if (!orderNo) {
        this.$confirm("请输入订单编号！", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false,
        })
          .then(() => {})
          .catch(() => {});
        return;
      }

      this.cancelOrderLoading = true;
      const url = this.$root.commonPreUrl + "/index/cancelOrder";
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userToken,
      };
      axios
        .post(url, { order_no: orderNo }, { headers: headers })
        .then((response) => {
          const resd = response.data || {};
          if (resd.code == "200") {
            this.cancelOrderFormVisible = false;
            this.cancelOrderNo = "";
            this.$confirm(resd.msg || "订单取消成功！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false,
            })
              .then(() => {})
              .catch(() => {});
            if (this.activeTab === "sending") {
              this.getSending();
            } else {
              this.getList();
            }
          } else {
            this.$confirm(resd.msg || resd.message || "订单取消失败！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false,
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch((error) => {
          console.error("取消订单失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
            return;
          }
          this.$confirm("取消订单失败，请稍后重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false,
          })
            .then(() => {})
            .catch(() => {});
        })
        .finally(() => {
          this.cancelOrderLoading = false;
        });
    },
    getImageUrl(flag) {
      // 根据数字转换成图片名称，
      if (flag == 0) {
        return require("@/assets/qz0.png");
      } else if (flag == 1) {
        return require("@/assets/qz1.png");
      } else if (flag == 2) {
        return require("@/assets/qz2.png");
      } else if (flag == 3) {
        return require("@/assets/qz3.png");
      } else if (flag == 4) {
        return require("@/assets/qz4.png");
      } else if (flag == 5) {
        return require("@/assets/qz5.png");
      } else {
        return "";
      }
    },
    addClass: function (plat) {
      this.platform = plat;
      this.getCk();
    },
    sendCode() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      if (this.countdown > 0) {
        return;
      }
      let phoneNum = this.phoneForm.phone;
      if (phoneNum == "" || phoneNum == null) {
        // alert("请输入手机号！");
        this.$confirm("请输入手机号！", "提示", {
          confirmButtonText: "确认",
          showCancelButton: false, //是否显示取消按钮
        })
          .then(() => {
            return;
          })
          .catch(() => {});
        return;
      }
      const url = this.$root.commonPreUrl + "/sendVerificationCode";
      const res = axios.get(url, {
        params: { phone: phoneNum },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 设置倒计时时间，这里设置为60秒
            this.countdown = 60;
            // 创建倒计时
            const intervalId = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown -= 1;
              } else {
                clearInterval(intervalId);
              }
            }, 1000);
          } else {
            this.$confirm(
              "发送失败！原因：" + JSON.stringify(response.data.message),
              "提示",
              {
                confirmButtonText: "确认",
                showCancelButton: false, //是否显示取消按钮
              }
            )
              .then(() => {
                return;
              })
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
              
            })
            .catch(() => {});
          return;
        });
    },
    sendCodeCheck(){
      this.sendCodeFormVisible = true;
    },
    updateUserInfo(){
      const userToken = Cookies.get("view_userToken");
      const userId = Cookies.get("view_userId");
      if (userToken == undefined || userId == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return "";
      }
      const url = this.$root.commonPreUrl + "/verifyVerificationCode";
      const res = axios.get(url, {
        params: { phone: this.phoneForm.phone, code: this.phoneForm.code },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            // 提交修改手机号
            const url = this.$root.commonPreUrl + "/index/updateUserInfo";
            this.sendtelList.push(this.phoneForm.phone);
            let sendtel_json = JSON.stringify(this.sendtelList);
            
            const res1 = axios.get(url, {
              params: { id: userId, send_name: this.send_name, send_tel: sendtel_json  },
              headers: {
                Authorization: "Bearer " + userToken,
              },
            });
            res1
              .then((response) => {
                const resd1 = response.data;
                if (resd1.code == "200") {
                  this.sendCodeFormVisible = false;
                  this.$confirm(resd1.message, "提示", {
                    confirmButtonText: "确认",
                    showCancelButton: false, //是否显示取消按钮
                  })
                    .then(() => {
                    
                    })
                    .catch(() => {});
                }else {
                  this.$confirm(resd1.message, "提示", {
                    confirmButtonText: "确认",
                    showCancelButton: false, //是否显示取消按钮
                  })
                    .then(() => {
                    
                    })
                    .catch(() => {}); 
                }
              })

          } else {
            this.$confirm(resd.message, "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
             
            })
            .catch(() => {});
          return;
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          this.$confirm("操作失败！请稍后刷新重试。", "提示", {
            confirmButtonText: "确认",
            showCancelButton: false, //是否显示取消按钮
          })
            .then(() => {
             
            })
            .catch(() => {});
          return;
        });
    },
    sendTelClick(){
      let sendName = this.send_name;
      if (sendName=="") {
        sendName = "1"
      }
      this.lpfsQuery.fjr = sendName + "," + this.send_tel;
    },
    
    liClicked(item){
      this.send_tel = item;
      let sendName = this.send_name;
      if (sendName=="") {
        sendName = "a1"
      }
      this.lpfsQuery.fjr = sendName + "," + this.send_tel;
    },
    deleteItem(item) {
      this.sendtelList = this.sendtelList.filter(i => i !== item);
      const userToken = Cookies.get("view_userToken");
      const userId = Cookies.get("view_userId");
      if (userToken == undefined || userId == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return "";
      }
      const url = this.$root.commonPreUrl + "/index/updateUserInfo";
      let sendtel_json = JSON.stringify(this.sendtelList);
      
      const res1 = axios.get(url, {
        params: { id: userId, send_name: this.send_name, send_tel: sendtel_json  },
        headers: {
          Authorization: "Bearer " + userToken,
        },
      });
      res1
        .then((response) => {
          const resd1 = response.data;
          if (resd1.code == "200") {
            this.sendCodeFormVisible = false;
            this.$root.getUserInfo();
            this.$confirm("手机号删除成功！", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
              
              })
              .catch(() => {});
          }else {
            this.$confirm(resd1.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
              
              })
              .catch(() => {}); 
          }
        })
    },
    selectGift(item, index) {
      this.selectedGiftIndex = index;
      this.lpfsQuery.goods_id = item.id || "";
      this.lpfsQuery.goods_price = item.member || "";
    },
  },
};
</script>

<style scoped>
.btncs_blue {
  font-size: 13px;
  background-color: #0850fc;
  color: white;
  height: 38px;
  border-radius: 0.5em;
  margin-left: 59px;
  margin-top: 12px;
}
.btncs_gray {
  font-size: 13px;
  background-color: rgb(187 187 187);
  color: white;
  height: 38px;
  border-radius: 0.5em;
  margin-left: 59px;
  margin-top: 12px;
}
.lipin_img_div {
  width: 5vw;
  /* height: 5vw; */
  /* min-height: 22.5vh; */
  border: white 2px solid;
  border-radius: 1.3em;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  /* background-color: #d5e1ff; */
  color: rgb(37, 37, 37);
  margin-left: 20px;
  margin-top: 0px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lipin_img_div.selected {
  border: #0850fc 2px solid;
  box-shadow: 0px 0px 15px rgba(8, 80, 252, 0.6);
  transform: scale(1.05);
}
.gift-price {
  font-size: 16px;
  text-align: center;
  margin-top: 5px;
  padding: 0 2px;
  overflow: hidden;
  color: #ff0000;
}

.gift-name {
  font-size: 12px;
  text-align: center;
  margin-top: 5px;
  padding: 0 2px;
  overflow: hidden;
  color: #333;
  display: inline-block;
}
.lipin_img {
  width: 4.7vw;
  height: 4.6vw;
  padding-left: 0.1vw;
  margin-top: 0.1vw;
  border-radius: 1em;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
.zfxx {
  /* margin-top: 3px; */
  display: flex;
  align-items: center; /* 垂直居中 */
}
.djb {
  color: rgb(120 120 120);
  margin-left: 10px;
}
.djb_desc {
  font-weight: bold;
  font-size: 15px;
  color: #202020;
  margin-left: 20px;
  padding-top: 3px;
}
.select_span {
  font-size: 14px;
  border: #dcdfe6 1px solid;
  border-radius: 4px;
  height: 32px;
  /* line-height: 34px;
  padding: 11px; */
  color: #606266;
  margin-left: 20px;
  margin-top: 5px;
  padding-bottom: 10px;
}
select {
  height: 30px;
  /* border: #c3c3c3 solid 1px; */
  border: none;
  border-radius: 0.4em;
  outline: none;
}
select:focus {
  outline: none; /* 移除轮廓线 */
}
/* 去掉option的边框 */
option {
  border: none;
  outline: none;
}
.select-option:hover {
  border-color: #0000ff;
  background-color: #ffff00;
}
input {
  height: 30px;
  /* border: #c3c3c3 solid 1px; */
  border: white solid 0px;
  border-radius: 0.4em;
}
input:focus {
  outline: none; /* 移除轮廓线 */
}
.borderless {
  /* border: white 1px solid; */
  box-shadow: none;
  height: 28px;
  width: 156px;
  margin-left: -5px
  /* margin-top: -3px; */
}

.el-button {
  font-size: 12px;
  border-color: #0850fc; /* 边框颜色 */
  color: white; /* 文字颜色 */
  background-color: #0850fc; /* 默认背景色 */
  height: 34px;
  padding: 10px 12px;
  border-radius: 0.5em;
}
.el-button:hover {
  border-color: #5185ff;
  background-color: #5185ff; /* 悬浮时的颜色 */
}
.platDiv {
  width: 80px;
  height: 32px;
  border: #0850fc solid 1px;
  border-radius: 0.5em;
  float: left;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin-right: 20px;
}
.platSpan{
  font-size: 16px;
  padding: 0px 7px;
}
.spanColors {
  font-weight: bold;
  background-color: #0850fc;
  color: white;
}
.form a {
  position: absolute;
  text-decoration: none;
  right: 10px;
  color: #a9a9a9;
  border-left: 1px solid #ccc;
  align-items: center;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/syncOrder/plSend/index.vue